export const INPUT_MAX_LENGTH = 12
